import { useTheme } from '@mui/styles';
import { useEffect, useState, useRef } from 'react';
import { useWindowSize } from '@qrios/frontend-library';

export type IsMobileState = boolean | 'initialized';

const getIsMobile = (currentWidth: number, maxWidth: number): boolean => currentWidth < maxWidth;

export const useMobile = () => {
  const { width } = useWindowSize();
  const theme = useTheme();
  const ref = useRef<number>();

  const [isMobile, setIsMobile] = useState<IsMobileState>('initialized');

  useEffect(() => {
    ref.current = width;

    if (ref.current !== 0) {
      setIsMobile(getIsMobile(width, theme.breakpoints.values.sm));
    }
  }, [theme.breakpoints.values.sm, width]);

  return { isMobile };
};
